export default defineAppConfig({
  SITE_NAME: "DOGFUL(ドッグフル)",
  SITE_NAME_WITH_CATCH: "DOGFUL(ドッグフル)|愛犬と一緒に素敵な毎日を",
  SITE_HOST_NAME: "www.dog-ful.com",
  API_BASE_URL: "/api"
});
